package org.ksdfv.thelema.img

import org.ksdfv.thelema.data.IByteData
import org.ksdfv.thelema.fs.IFile
import kotlin.native.concurrent.ThreadLocal

/** @author zeganstyl */
@ThreadLocal
object IMG: IImg {
    lateinit var proxy: IImg

    override fun image(): IImageData = proxy.image()

    override fun load(
        url: String,
        out: IImageData,
        sourceLocation: Int,
        response: (status: Int, img: IImageData) -> Unit
    ): IImageData = proxy.load(url, out, sourceLocation, response)

    override fun load(file: IFile, out: IImageData, response: (status: Int, img: IImageData) -> Unit): IImageData =
        proxy.load(file, out, response)

    override fun load(byteArray: ByteArray, out: IImageData, response: (status: Int, img: IImageData) -> Unit): IImageData =
        proxy.load(byteArray, out, response)

    override fun load(data: IByteData, out: IImageData, response: (status: Int, img: IImageData) -> Unit): IImageData =
        proxy.load(data, out, response)
}
